import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { isQuestionCategoryPostable } from '../../../../../data/filters/questions/isQuestionCategoryPostable';
import ButtonLink from '../../../../elements/ButtonLink';
import { isQAActive } from '../../../../../data/filters/questions/isQAActive';

function PostQuestFooterButton(props) {
    const { event } = props,
        isQAOpen = isQAOpen,
        i18n = useI18n(),
        postableCategories = event.question_categories.filter(isQuestionCategoryPostable);

    if (!event.joined) return null;
    if (!isQAActive(event)) return null;
    if (!event.default_question_category && !postableCategories.length) return null;

    return (
        <ButtonLink style={event._local.styles.button} href={'./create'}>
            {i18n['label.post.quest']}
        </ButtonLink>
    );
}

export default PostQuestFooterButton;
